import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchJobtitle from "utils/fetch/FetchJobtitle";

export default class FetchCachedJobtitle
{
	static logName = 'FetchCachedJobtitle';
	static values = null;
	static cacheUpdatedAt = null;
	
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'jobtitles',
				tables: [ 'jobtitles' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess({
							jobtitles: this.values
						})
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}
	
	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchJobtitle.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( { jobtitles = null } ) => {
						// Save to object
						this.process( jobtitles );


						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, jobtitles, true );

						if( callbackSuccess !== null ) {
							callbackSuccess({
								jobtitles: jobtitles
							});
						}
					}
				})
			);
		}
		);
	}
	
	static process = ( jobtitles ) => {
		this.values = jobtitles;
		store.dispatch( addDataByGuid( dataConstants.JOBTITLES, this.values ) );
	}
}
